import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { GenericLinkDirective } from '@portal-front/portal-auth-in-memory-router';

@Component({
  standalone: true,
  selector: 'ef-create-account-features-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgOptimizedImage, GenericLinkDirective, TranslateModule],
  template: `
    <div
      class="md:w-full md:h-full bg-gray-10 text-gray-20 flex items-center justify-center py-6 md:py-0 min-h-[400px]"
    >
      <div class="flex flex-col gap-3">
        @if (showRegistrationButton()) {
          <h2 class="text-heading-04 md:text-heading-03 text-black text-left">{{
            'create-account-banner-header-text' | translate
          }}</h2>
          <button (click)="onRegisterClick()" class="btn btn-primary btn-xl btn-outline  mt-6"
            >{{ 'create-account-banner-button-text' | translate }}
          </button>
          <h6 class="text-black text-heading-06 mt-8">{{ 'create-account-banner-benefits-text' | translate }}</h6>
        } @else {
          <h2 class="block text-heading-04 md:text-heading-03 text-black text-left">{{
            'create-account-banner-benefits-text-2' | translate
          }}</h2>
        }

        <ul>
          @for (desc of featuresList; track desc) {
            <li class="flex content-center mb-4 last:mb-2">
              <img alt="lfeature icon" width="24" height="24" [ngSrc]="desc.icon" class="inline-block" />
              <span class="text-body-01 text-black ml-4">{{ desc.description | translate }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
  `,
})
export class EfCreateAccountFeaturesBannerComponent {
  @Output() registerClick = new EventEmitter<void>();

  public readonly featuresList = [
    {
      icon: 'empikfoto/icons/list-bullets.svg',
      description: 'create-account-banner-history-benefit',
    },
    {
      icon: 'empikfoto/icons/picture.svg',
      description: 'create-account-banner-projects-benefit',
    },
    {
      icon: 'empikfoto/icons/discount.svg',
      description: 'create-account-banner-discounts-benefit',
    },
    {
      icon: 'empikfoto/icons/star.svg',
      description: 'create-account-banner-special-discount-benefit',
    },
    {
      icon: 'empikfoto/icons/map-marker.svg',
      description: 'create-account-banner-free-delivery-benefit',
    },
  ];

  public onRegisterClick(): void {
    this.registerClick.emit();
  }

  public readonly showRegistrationButton = input<boolean>(true);
}
